import { inject } from '@angular/core';
import { UserService } from '../providers/auth/user.service';
import { CanActivateFn, Router } from '@angular/router';

export const isAuthenticated: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (userService.isLoading === true) {
    return router.parseUrl('/loading');
  }

  if (userService.adfsUser === undefined) {
    return router.parseUrl('/login');
  }
  if (userService.needsImpersonate()) {
    return router.parseUrl('/mnt/impersonate');
  }
  return userService.isAuthenticated();
};
